/**
 * Created by joaomeireles on 19/10/2017.
 */

window.processNS = {

    action: null,
    row: null,
    callback: null,
    params: null,

    execute: function (action, row, callback, params) {

        if (action.wf_action_id == globalConstants.ACTION_FINALIZE_EPISODE){
            processNS.actionType = globalConstants.PROCCESS_ACTION_TYPE_FINALIZE;
        } else if(action.wf_action_id == globalConstants.ACTION_UNDO_FINALIZE_EPISODE){
            processNS.actionType = globalConstants.PROCCESS_ACTION_TYPE_REOPEN;
        } else {
            processNS.actionType = action.wf_action_id;
        }

        processNS.action = action;
        processNS.row = row;
        processNS.callback = callback;
        processNS.params = params;

        processNS.checkProccessValidations();
        

    },

    reopenProccess: function (callback, params) {

        $.post('/physiotherapy/reopen_physiotherapy', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                } else {
                    if (callback){
                        callback();
                    } else if (processNS.callback) {
                        processNS.callback();
                    }
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });

    },

    finalizeProccess: function () {
        var params = processNS.params;

        $.fancybox.close();
        $.post('/physiotherapy/finalize_physiotherapy', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                } else {
                    if (processNS.callback) {
                        processNS.callback();
                    }
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });

    },

    checkProccessInvoiced: function () {

        var params = processNS.params;

        $.getJSON('/treatment/check_process_month_entity_invoiced', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                var process_month_end_date = '';
                var _date = new Date();

                if (params.date) {
                    process_month_end_date = params.date.substr(6, 4) +
                        params.date.substr(3, 2) +
                        '01';

                } else {
                    process_month_end_date = _date.getFullYear() +
                        _date.getMonth() +
                        '01';
                }


                if (data.length > 0) {
                    var all_dates = '';
                    $.each(data, function (index, value) {
                        debug.log(index, value);
                        if (index == 0) {
                            all_dates = value.sale_transaction_date_desc;
                        } else {
                            all_dates = all_dates + ' | ' + value.sale_transaction_date_desc;
                        }

                    });

                    Hades.hideLoading();

                    if (processNS.actionType == globalConstants.PROCCESS_ACTION_TYPE_FINALIZE){

                        if ( (data[data.length-1].sale_transaction_date_desc.substr(6, 4) +
                                data[data.length-1].sale_transaction_date_desc.substr(3, 2) +
                                '01'
                            ) >= process_month_end_date ){

                            bootbox.alert(data[0].finalized_message.replace('#sale_transaction_date#', data[data.length-1].sale_transaction_date_desc));

                        }else{
                            processNS.finalizeProccess();
                        }
                        //}

                    } else if (processNS.actionType == globalConstants.PROCCESS_ACTION_TYPE_REOPEN) {
                        if (data[0].actual_month_in_lot === 't') {
                            bootbox.alert(GlobalTranslations['APP_LABEL.2455']);
                        } else if (data[0].invoice_has_credit_note === 'f') {
                            bootbox.alert(GlobalTranslations['APP_LABEL.TREATMENT_ALREADY_INVOICED'].replace('#sale_transaction_date#', all_dates))
                        }else{
                            bootbox.confirm(data[0].reopen_message.replace('#sale_transaction_date#', all_dates), function(success){
                                Hades.showLoading();

                                if(success){
                                    processNS.callback();

                                } else {
                                    Hades.hideLoading();
                                    $.fancybox.close(true);
                                }
                            });
                        }
                    }
                }
                else {

                    processNS.checkProccessInLot();

                }

            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
            });


    },

    checkProccessInLot: function(){

        var params = processNS.params;

        $.getJSON('/billing/entities/verify_credential_added_to_lot', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                if (!data) {


                    if (processNS.actionType == globalConstants.PROCCESS_ACTION_TYPE_FINALIZE){

                        processNS.finalizeProccess();

                    } else if (processNS.actionType == globalConstants.PROCCESS_ACTION_TYPE_REOPEN) {

                        processNS.callback();
                    }
                }
                else {
                    bootbox.alert(GlobalTranslations['APP_LABEL.2455']);
                    $.fancybox.close(true);
                    Hades.hideLoading();
                }

            })
            .fail(function (xhr, status, error) {
                Hades.showError();
                Hades.hideLoading();
            });

    },

    checkProccessValidations: function () {

        processNS.checkProccessInvoiced();
    }


};





